export default "__VITE_ASSET__046424dd__"